<quick-preview-panel
  *ngIf="form"
  [heading]="isNew ? 'Register User' : 'Edit User'"
  [color]="form.valid ? 'accent' : 'warn'"
>
  <div class="p-3 pt-4" [formGroup]="form" *ngIf="(isNew || existing)">
    <div class="row p-0 m-0">
      <input type="hidden" formControlName="id">
      <input type="hidden" formControlName="system">
      <div
        [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Email Address</mat-label>
          <input type="text" matInput class="d-block" formControlName="id">
          <mat-error *ngIf="form.get('id')!.hasError('required')">
            Required field
          </mat-error>
          <mat-error *ngIf="form.get('id')!.hasError('email')">
            Invalid email address
          </mat-error>
          <mat-error *ngIf="form.get('id')!.hasError('exists')">
            Already exists
          </mat-error>
        </mat-form-field>
      </div>
      <div
        [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Is System</mat-label>
          <mat-select formControlName="system">
            <mat-option [value]="false">No</mat-option>
            <mat-option [value]="true">Yes</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div
        [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-6 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Description</mat-label>
          <input type="text" matInput class="d-block"
                 formControlName="description">
        </mat-form-field>
      </div>
    </div>
    <div class="row p-0 m-0">
      <div class="col-12 col-md-9 col-lg-6 m-0 p-0 pe-2">
        <mat-form-field class="d-block" >
          <mat-label>Tenants</mat-label>
          <mat-select class="d-block" [multiple]="true" formControlName="tenants">
            <mat-option *ngFor="let mt of tenants"
                        [value]="mt.id">{{mt.id}} - {{mt.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row p-0 m-0 ms-4 my-4" formArrayName="claims">
      <h4 class="fw-light">Claims</h4>
      <div class="row m-0 p-0 pe-2" *ngFor="let fg of messagesArrayControls; let index=index" [formGroup]="fg">
        <div class="col-12 col-md-6 col-lg-3 m-0 p-0 pe-2">
          <mat-form-field class="d-block">
            <mat-label>Type</mat-label>
            <mat-select formControlName="type">
              <mat-option *ngFor="let ct of claimTypes" [value]="ct">{{ct}}</mat-option>
            </mat-select>
            <mat-error *ngIf="fg.get('type')!.hasError('required')">
              Required field
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-lg-9 m-0 p-0 pe-3">
          <div class="d-flex">
            <div class="flex-grow-1 pe-2">
              <mat-form-field class="d-block">
                <mat-label>Value</mat-label>
                <input type="text" matInput formControlName="value">
                <mat-error *ngIf="fg.get('value')!.hasError('required')">
                  Required field
                </mat-error>
              </mat-form-field>
            </div>
            <button mat-fab color="accent" (click)="deleteClaimsControlAtIndex(index)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <actions-container [ngClass]="'me-4'">
        <button
          color="primary"
          mat-raised-button (click)="addClaimFormControl()">Add Claim</button>
      </actions-container>
    </div>
    <actions-container [ngClass]="'pt-4'">
      <back-button></back-button>
      <button
        [disabled]="!form.valid"
        color="primary"
        class="mx-2"
        mat-raised-button
        (click)="save()"
      >
        <mat-icon class="valign-middle">save</mat-icon>
        Save
      </button>

    </actions-container>
  </div>


  {{form.value | json}}
</quick-preview-panel>
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<error-panel ngClass="my-4" [error]="error"></error-panel>

